// extracted by mini-css-extract-plugin
export default {"previousVerifications":"PostVerificationExpiredBar-module__previousVerifications--D4vvq","animatedBackground":"PostVerificationExpiredBar-module__animatedBackground--3HDE6"};